import { RequestService } from '../../../../common/services/RequestService';
import { GET_FILTER_EXECUTORS } from '../constants';
import {
  adjustExecutorsData,
  adjustExecutorsFiltersRequest,
} from './adjustExecutorsData';

export const getFilterExecutorsRequest = async (profileId, filters) => {
  const response = await RequestService.get(
    GET_FILTER_EXECUTORS.replace('{profile_id}', profileId),
    {
      params: adjustExecutorsFiltersRequest(filters),
    }
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(executor => adjustExecutorsData(executor))
  );
};
